import { Component, OnInit, signal, WritableSignal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { SelectModule } from 'primeng/select';
import { locales } from './locales';

@Component({
  selector: 'carehub-language-selector',
  imports: [SelectModule, FormsModule, ButtonModule, MenuModule],
  standalone: true,
  templateUrl: './language-selector.component.html',
  styleUrl: './language-selector.component.scss',
})
export class LanguageSelectorComponent implements OnInit {
  locales: WritableSignal<string[]> = signal([]);
  selected: WritableSignal<string> = signal('');

  ngOnInit(): void {
    this.locales.set(locales);
    if ($localize.locale) {
      this.selected.set($localize.locale);
    }
  }

  setSelected(selected: string): void {
    this.selected.set(selected);
    if (selected === $localize.locale) {
      return;
    }

    const segments: string[] = window.location.pathname.split('/');
    segments[1] = selected;

    const newUrl: string = segments.join('/');
    const queryParams: string = window.location.search;

    window.location.href = newUrl + queryParams;
  }
}
